export default __webpack_public_path__ + "static/media/commercial.49b359df.jpg";